import { render } from "./PlantPage.vue?vue&type=template&id=7b7db4a6&ts=true"
import script from "./PlantPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlantPage.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/Users/voquanghoa/code/medicinal-plant/MedicinalPlant.Frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/PlantPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b7db4a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b7db4a6', __exports__)) {
    api.reload('7b7db4a6', __exports__)
  }
  
  module.hot.accept("./PlantPage.vue?vue&type=template&id=7b7db4a6&ts=true", () => {
    api.rerender('7b7db4a6', render)
  })

}


export default __exports__